<template>
  <div style="pointer-events: auto;">
    <div class="field has-addons">
      <div class="control" style="background-color: whitesmoke;">
        <div v-if="!location && showLocTooltip" class="tooltip">
          <div class="is-pulled-right">
            <span @click="$store.dispatch('toggleLocTooltip')" class="icon cursor">
              <i class="fas fa-times"></i>
            </span>
          </div>
          <div style="padding-right:30px;">
            <span class="icon">
              <i class="fa fa-exclamation-triangle"></i>
            </span> Aktivieren Sie die Ortungsdienste um alle Funktionen nutzen zu können
            <a @click="showLocInfo=!showLocInfo">Warum?</a>
          </div>
        </div>
        <a
          class="button is-info square-button"
          @click="saveVisit"
          :disabled="loading"
          :loading="loading"
          :class="{ 'is-loading' : loading }"
        >
          <span class="icon">
            <i class="fa fa-location-arrow"></i>
          </span>
        </a>
      </div>

      <div class="control" style="background-color: whitesmoke;">
        <a class="button square-button" @click="centerCard" title="Karte zentrieren">
          <span class="icon">
            <i class="fas fa-home"></i>
          </span>
        </a>
      </div>

      <div class="control is-expanded has-icons-right" v-if="cookies_maps">
        <GmapAutocomplete
          @place_changed="setPlace"
          class="input is-large"
          title="Ortung aktivieren"
          id="rangeSearch"
          :placeholder="location ? 'Umkreissuche' : 'Lokalisierung inaktiv'"
        ></GmapAutocomplete>
        <span
          class="icon is-right cursor"
          :disabled="!location"
          @click="clearInput"
          title="Feld leeren"
          style="pointer-events: auto;"
        >
          <i class="fas fa-times"></i>
        </span>
      </div>

      <div style="flex-grow:1;padding:15px;height:54px;%;border-radius:0;color:#209cee;background:whitesmoke;border-top:1px solid #dbdbdb;border-bottom:1px solid #dbdbdb;box-sizing:border-box;" v-else @click="$store.commit('editCookies')">
                <u>Karten deaktiviert</u> &nbsp;
                <i class="fas fa-cog" style="float:right;margin-top:5px;color:#209cee;"></i>
              </div>

      <div class="control is-hidden-desktop">
        <a class="button square-button" @click="filterInfo=!filterInfo">
          <span class="icon">
            <i class="fa fa-filter"></i>
          </span>
        </a>
      </div>
    </div>

    <div id="modal" class="modal is-active" v-if="showLocInfo">
      <div class="modal-background" @click="showLocInfo=!showLocInfo"></div>
      <div class="modal-content">
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content has-text-centered">
                <span class="title">Lokalisierung</span>

                <ul style="margin-left: 0;list-style: none;">
                  <li>Angebote im
                    <strong>Umkreis ihrer aktuellen Position</strong>
                  </li>
                  <li>
                    <strong>Entfernungsangaben</strong> zu den Angeboten
                  </li>
                  <li>Suchen Sie im
                    <strong>Umkreis eines beliebigen Standorts</strong>
                  </li>
                  <li>Starten Sie die
                    <strong>Navigation</strong> mit nur einem Klick
                  </li>
                  <li>Ihren Standort wird nur lokal auf Ihrem Gerät gespeichert
                  </li>
                </ul>

                <p>
                  <span @click="saveVisit" class="tag is-success is-rounded is-medium cursor">
                    <span class="icon">
                      <i class="fa fa-check"></i>
                    </span>&nbsp;Jetzt aktivieren
                  </span>
                  <span
                    @click="showLocInfo=!showLocInfo"
                    class="tag is-rounded is-medium is-white cursor"
                  >Später</span>
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        style="margin-top: 52px;"
        @click="showLocInfo=!showLocInfo"
      ></button>
    </div>

    <!----------- filter selector modal ---------------------------------->
    <div class="modal is-active" v-show="filterInfo">
      <div class="modal-background" @click="filterInfo=!filterInfo"></div>
      <div class="modal-card card-margin">
        <header class="modal-card-head">
          <p class="modal-card-title">Filter wählen</p>
          <a class="delete" aria-label="close" @click="filterInfo=!filterInfo"></a>
        </header>
        <section class="modal-card-body">
          <div class="field is-grouped is-grouped-multiline">
            <div v-for="(i, index) in allTags" :key="index" class="control">
              <div class="tags has-addons">
                <span
                  @click="filterBy(i)"
                  class="tag is-rounded cursor is-medium"
                  :class="[ {'tag_reset' : (filterContentBy.indexOf(i) === -1)}, 'tag_' + i ]"
                ></span>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a class="button" @click="filter" v-if="filterContentBy.length">Alles anzeigen</a>
          <a class="button is-primary" @click="filterInfo=!filterInfo">Fertig</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLocInfo: false,
      filterInfo: false
    }
  },
  methods: {
    // re-locate or activate localization
    saveVisit() {
      this.$store.dispatch('getLocation')
      this.showLocInfo = false
    },
    filterBy(v) {
      this.$store.commit('filterContentBy', v)
    },
    setPlace(place) {
      if (place.geometry.location.lat) {
        this.$store.commit('setStandort', place.formatted_address)
        const pos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.$store.commit('setPos', pos)
        this.$store.commit('setCenter', pos)
        this.$store.commit('sortContent')
        this.$store.commit('setZoom', 13)
      }
    },
    centerCard() {
      this.$store.commit('setCenter', {
        lat: 48.7913791,
        lng: 15.660817899999984
      })
      this.$store.commit('setZoom', 10)
    },
    clearInput() {
      this.$store.commit('setStandort', '')
      document.getElementById('rangeSearch').focus()
    },
    filter() {
      this.$store.dispatch('filterContent')
      this.filterInfo = !this.filterInfo
    }
  },
  computed: {
    cookies_maps() {
      return this.$store.getters.cookies_maps
    },
    filterContentBy() {
      return this.$store.getters.filterContentBy
    },
    standort() {
      return this.$store.getters.standort
    },
    loading() {
      return this.$store.getters.loading
    },
    location() {
      return this.$store.getters.location
    },
    filterContent() {
      return this.$store.getters.filterContent
    },
    allTags() {
      return this.$store.getters.allTags
    },
    showLocTooltip() {
      return this.$store.getters.showLocTooltip
    }
  }
}
</script>

<style scoped>
.square-button {
  border-radius: 0 !important;
  height: 54px;
  width: 54px;
}
.input {
  height: 54px;
}
</style>
